// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2V2QJ","label":"styles_label__YSCA3"};